import React, { useContext, useEffect, useMemo, useState } from 'react'
import { AuthContext } from '../contexts/AuthContext';
import { DataContext, fetchAll } from '../contexts/DataContext';
import styled from 'styled-components';
import AppPage from '../layouts/AppPage';
import { DEFAULT_TITLE, STATIC_URL } from '../lib/settings';
import { parseMarkDownLinks } from '../lib/utils/parse';
import { metaTags } from '../lib/utils/metaTags';

export default function Books() {
  const { api } = useContext(AuthContext);
  const { books, setBooks } = useContext(DataContext);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (books) return;
    const getBooks = async () => {
      setIsLoading(true);
      try {
        const data = await fetchAll(api.getBooks);
        setBooks(data.sort((a, b) => a.display_order - b.display_order));
      } catch (error) {
      };
      setIsLoading(false);
    };
    getBooks();
  }, [api, books, setBooks]);

  const MetaTags = useMemo(() => {
    const firstBook = books && books.length > 0 ? books[0] : null;
    return metaTags({
      title: `${DEFAULT_TITLE} | Книжная серия`,
      description: books?.map(book => book.annotation).join(' | '),
      image: firstBook?.image_path,
      url: 'https://chimeras.world/books/'
    })
  }, [books]);

  return (
    <AppPage>
      {MetaTags}
      {!isLoading && books &&
      <Wrapper>
        <h2>книжная серия</h2>
        <ul>
          {books.map((book, index) => (
            <Book key={index}>
              <div className="image-container">
                <img src={`${STATIC_URL}/${book.image_path}`} alt='' />
              </div>
              <div className="annotation">
                {book.annotation.split('\n').map((item, index) => (
                  <p key={index} dangerouslySetInnerHTML={{__html: parseMarkDownLinks(item)}}></p>
                ))}
              </div>
              
            </Book>
          ))}
        </ul>
      </Wrapper>
      }
    </AppPage>
  )
}

const Wrapper = styled.div`
  padding: 50px 20px 0 20px;

  display: flex;
  flex-direction: column;
  gap: 2rem;

  & h2 {
    font-size: 1.125rem;
    font-weight: 700;
    font-family: var(--primary-font);
  }

  ul {
    display: flex;
    flex-direction: column;
    gap: 5rem;
    list-style: none;
    padding: 0;
  }

  @media (min-width: 768px) {
    margin-top: 4rem;
    padding: 0 var(--main-side-padding);
  }
`;

const Book = styled.li`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  .image-container {
    width: 100%;
  }

  img {
    width: 100%;
    height: auto;
  }

  & .annotation p {
    font-size: 1rem;
    font-family: var(--secondary-font);
    min-height: 1rem;
  }

  a {
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }

  @media (min-width: 768px) {
    flex-direction: row;
    gap: 4rem;

    .image-container {
      flex: 0 0 30%;
    }

    .annotation {
      flex: 0 0 50%;
    }
  }
`;